// SPDX-FileCopyrightText: 2026 Ebiose AI
// SPDX-License-Identifier: LicenseRef-Ebiose-Proprietary
// All rights reserved. Confidential — unauthorized distribution prohibited.

import { useMaintenanceStore, maintenanceStore } from "@/stores/maintenance"

// Flips isBackendDown to true after MAINTENANCE_THRESHOLD consecutive 5xx/timeout/network
// errors; resets to false on any 2xx-3xx response (M6 MaintenanceDetector).
// Uses useSyncExternalStore internally — no direct Zustand dependency needed.
export function useBackendStatus(): { isBackendDown: boolean } {
  const { isBackendDown } = useMaintenanceStore()
  return { isBackendDown }
}

// Synchronous snapshot for non-React contexts (e.g. test assertions, http-client interceptor).
export function getBackendStatus(): { isBackendDown: boolean; consecutiveFailures: number } {
  return maintenanceStore.getSnapshot()
}
